import React from 'react';


import { CSSTransition } from 'react-transition-group';
import { range } from 'lodash-es';

import { history } from '../history'

import {
  REQUEST_SUCCESS,
} from '../constants/requestStates'

import {
  NeuroFitNamedLogoSvg,
} from '../constants/svgs'

import {
  subdomainUrls,
  recordLinkClickGA,
  ProductionSupportBaseUrl,
  getCoachUuidFromQueryString,
} from '../utils'

import DysregulationQuizResults from './common/DysregulationQuizResults'

const containerStyle = {textAlign: "start", height: "100%", width: "100vw", overflowX: "hidden", overflowY: "scroll"}


class DysregulationQuizResultPage extends React.Component {
  render() {
    const {
      fetchQuizResult,
      safeAreaInsets,
      innerHeight,
      isIOSDevice,
      isAndroidDevice
    } = this.props

    return (
      <div style={{height: innerHeight}}>
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#EDEEF2"}}>
          <div style={{position: "fixed", top: 0, left: 0, right: 0, height: safeAreaInsets.top, backgroundColor: "#000000", zIndex: 2000}} />
          <div style={{position: "fixed", top: 0, left: 0, right: 0, boxShadow: "0px 2px 0px 0px black", display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12 + safeAreaInsets.top, paddingInlineStart: "min(40px, 7.5%)", paddingInlineEnd: 12, paddingBottom: 12, backgroundColor: "white", zIndex: 1000}}>
            <NeuroFitNamedLogoSvg
              logoSize={"min(4.25vw, 18px)"}
              color={"#000000"}
              onClick={() => window.location = "/"}
            />
          </div>
          <div 
            id={"landing-page-container"}
            className={"disable-scrollbars"}
            ref={elem => this.scrollingContainerRef = elem}
            style={containerStyle}
          >
            <div style={{textAlign: "start", width: "100vw"}}>
              <div style={{color: "white", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", height: innerHeight}}>
                <div style={{maxWidth: 600, color: "#000", minHeight: `calc(${innerHeight - 60 - safeAreaInsets.top}px - 5vh)`, paddingTop: `calc(${60 + safeAreaInsets.top}px + 5vh)`}}>
                  <DysregulationQuizResults
                    safeAreaInsets={safeAreaInsets}
                    quizResultState={REQUEST_SUCCESS}
                    quizResults={fetchQuizResult}
                    isIOSDevice={isIOSDevice}
                    isAndroidDevice={isAndroidDevice}
                    logAnalytics={false}
                    showTimestamp
                  />
                  <div style={{marginTop: 15, padding: 15, fontSize: "min(3.5vw, 16px)", fontFamily: "Futura", display: "flex", alignItems: "center", "justifyContent": "space-between"}}>
                    <div style={{display: "inline-block"}}>
                      <span style={{color: "#c1c4d2"}}>
                        {"© NEUROFIT 2024"}
                      </span>
                      <span style={{display: "inline-block", margin: "0px 0.5em", color: "#c1c4d2", fontSize: "min(2vw, 10px)"}}>
                        {"•"}
                      </span>
                      <span style={{color: "#c1c4d2"}}>
                        {"ALL RIGHTS RESERVED"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DysregulationQuizResultPage;